// AUTO-GENERATED partner skills (capacité partenaire, FR) keyed by internal name (iname).
// Base 184 from blaynem/paldex; newer Feybreak pals + variants (115) completed from palworld.gg FR (2026-08).
export const PARTNER_SKILLS = {
  "SheepBall": {
    "title": "Bouclier duveteux",
    "desc": "S'équipe sur le joueur lorsqu'il est appelé pour lui servir de bouclier. À affecter à une Ferme\r\npour lui faire produire de la Laine."
  },
  "PinkCat": {
    "title": "Langue-de-chat",
    "desc": "Porte les affaires du joueur lorsqu'il est dans l'équipe pour augmenter son poids max."
  },
  "ChickenPal": {
    "title": "Production d'œufs",
    "desc": "À affecter à une Ferme pour lui faire pondre un Œuf."
  },
  "Carbunclo": {
    "title": "Recul de Lifmunk",
    "desc": "Monte sur la tête du joueur lorsqu'il est appelé pour accompagner ses attaques avec un pistolet-mitrailleur."
  },
  "BluePlatypus": {
    "title": "Coud'surf",
    "desc": "Se tourne vers l'ennemi lorsqu'il est appelé et devient une planche de surf pour lui foncer dessus."
  },
  "BluePlatypus_Fire": {
    "title": "Coud'surf",
    "desc": "Se tourne vers l'ennemi lorsqu'il est appelé et devient une planche de surf pour lui foncer dessus."
  },
  "CuteFox": {
    "title": "Creuse et creuse",
    "desc": "À affecter à une Ferme pour lui faire extraire des objets du sol."
  },
  "FlyingManta": {
    "title": "Planeur sur brise",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Permet des déplacements rapides plus longs en plein vol."
  },
  "FlyingManta_Thunder": {
    "title": "Planeur sur brise",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Permet des déplacements rapides plus longs en plein vol."
  },
  "WoolFox": {
    "title": "Laine soyeuse",
    "desc": "Augmente l'attaque des Pals de type Non élém. lorsqu'il est dans l'équipe. À affecter à une Ferme pour lui faire produire de la Laine."
  },
  "KendoFrog": {
    "title": "Position Saut",
    "desc": "Lorsqu'activée, Croajiro, animé par une forte loyauté,\ngonfle son abdomen afin d'accumuler de l'énergie.\nLe joueur peut alors sauter sur son dos pour être propulsé haut dans les airs.\nAugmente l'attaque du joueur de 50~86 % jusqu'à son atterrissage."
  },
  "KendoFrog_Dark": {
    "title": "Posture Annonciatrice",
    "desc": "Lorsqu'activée, Croajiro Noct accumule de l'énergie grâce à sa loyauté et son ventre rebondi.\nLe joueur saute très haut lorsqu'il monte dessus.\nLorsqu'il est dans l'équipe, augmente de 25~40% les dégâts de type Ténèbres infligés aux points faibles. (effet non cumulable)"
  },
  "LeafMomonga": {
    "title": "Herbapulsion",
    "desc": "Lorsqu'il est dans l'équipe, Herbil ressuscite le joueur avec 30~60% de ses PV max lorsqu'il est mis K.O., grâce à ses pouvoirs apaisants."
  },
  "Ganesha": {
    "title": "Douche apaisante",
    "desc": "Restaure les PV du joueur en crachant une mystérieuse eau régénératrice lorsqu'il est appelé."
  },
  "PlantSlime": {
    "title": "Aide aux bûcherons",
    "desc": "Augmente les dégâts infligés par le joueur contre les arbres lorsqu'il est dans l'équipe."
  },
  "PlantSlime_Flower": {
    "title": "Aide aux bûcherons",
    "desc": "Augmente les dégâts infligés par le joueur contre les arbres lorsqu'il est dans l'équipe."
  },
  "SamuraiDog": {
    "title": "Soutien Sincère",
    "desc": "Les dégâts des armes de mêlée utilisées par le joueur augmentent de 10~35 % lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "CloverFairy": {
    "title": "Joyeux Trèfle",
    "desc": "Dans la base, le niveau de la capacité de travail Collecte des autres Pals du camp augmente de +1. (Effet non cumulable)"
  },
  "Hedgehog": {
    "title": "Bombe zap",
    "desc": "S'équipe dans la main lorsqu'il est appelé. Le lancer sur l'ennemi provoque une explosion de foudre à l'impact."
  },
  "Hedgehog_Ice": {
    "title": "Bombe glagla",
    "desc": "S'équipe dans la main lorsqu'il est appelé. Le lancer sur l'ennemi provoque une explosion de glace à l'impact."
  },
  "NegativeKoala": {
    "title": "Shot de caféine",
    "desc": "Boit une grande quantité de boisson énergisante lorsqu'il est appelé pour augmenter temporairement\r\net de façon drastique sa vitesse de déplacement."
  },
  "Penguin": {
    "title": "Lance-Pengullet",
    "desc": "Équipe un Lance-fusées lorsqu'il est appelé pour ensuite servir de projectile.\r\nEst mis K.O. suite à l'explosion provoquée par l'impact."
  },
  "Penguin_Electric": {
    "title": "Lance-Pengullet",
    "desc": "Équipe un Lance-fusées lorsqu'il est appelé pour ensuite servir de projectile.\r\nEst mis K.O. suite à l'explosion provoquée par l'impact."
  },
  "CaptainPenguin": {
    "title": "Guerrier des mers",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Feu est vaincu."
  },
  "CaptainPenguin_Black": {
    "title": "Guerrier des mers",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Feu est vaincu."
  },
  "WizardOwl": {
    "title": "Sagesse obscure",
    "desc": "Augmente l'attaque des Pals de type Ténèbres lorsqu'il est dans l'équipe."
  },
  "Alpaca": {
    "title": "Paca-laine",
    "desc": "Peut être utilisé comme monture pour se déplacer. À affecter à une Ferme\r\npour lui faire produire de la Laine."
  },
  "KingAlpaca": {
    "title": "Montagne de muscles",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "KingAlpaca_Ice": {
    "title": "Montagne de muscles",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "DreamDemon": {
    "title": "Charognard onirique",
    "desc": "Apparaît aux côtés du joueur lorsqu'il est dans l'équipe pour accompagner ses attaques avec des balles magiques."
  },
  "Monkey": {
    "title": "Fusil jovial",
    "desc": "Mitraille temporairement les ennemis qui s'approchent au fusil d'assaut lorsqu'il est appelé."
  },
  "Monkey_Fire": {
    "title": "Fusil jovial",
    "desc": "Mitraille temporairement les ennemis qui s'approchent au fusil d'assaut lorsqu'il est appelé."
  },
  "NightFox": {
    "title": "Impassible",
    "desc": "En combattant à ses côtés, confère le type Ténèbres aux attaques du joueur."
  },
  "LavaGirl": {
    "title": "Larmes de lave",
    "desc": "À affecter à une Ferme pour lui faire fabriquer un Organe d'allumage."
  },
  "FlameBambi": {
    "title": "Petite étincelle",
    "desc": "Augmente l'attaque des Pals de type Feu lorsqu'il est dans l'équipe."
  },
  "Bastet": {
    "title": "Jet de perles aux pourceaux",
    "desc": "À affecter à une Ferme pour lui faire extraire de l'Pièce d'or du sol."
  },
  "Bastet_Ice": {
    "title": "Jet de perles aux pourceaux",
    "desc": "À affecter à une Ferme pour lui faire extraire de l'Pièce d'or du sol."
  },
  "Boar": {
    "title": "Tête dure",
    "desc": "Peut être utilisé comme monture pour se déplacer. La roche se brise plus facilement lorsqu'il est monté."
  },
  "Kitsunebi": {
    "title": "Câlin de flammes",
    "desc": "S'équipe sur le joueur lorsqu'il est appelé pour faire office de lance-flammes."
  },
  "Kitsunebi_Ice": {
    "title": "Câlin de flammes",
    "desc": "S'équipe sur le joueur lorsqu'il est appelé pour faire office de lance-flammes."
  },
  "NegativeOctopus": {
    "title": "Calamar frit",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Permet de flotter plus longtemps en plein vol."
  },
  "NegativeOctopus_Neutral": {
    "title": "Calamar frit",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Permet de flotter plus longtemps en plein vol."
  },
  "CuteMole": {
    "title": "Détection de minerai",
    "desc": "Produit des microvibrations lorsqu'il est appelé pour détecter le minerai à proximité."
  },
  "Deer": {
    "title": "Gardien des bois",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut\r\net de briser le bois plus facilement lorsqu'il est monté."
  },
  "Deer_Ground": {
    "title": "Gardien des bois dorés",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut\r\net de briser le bois plus facilement lorsqu'il est monté."
  },
  "Garm": {
    "title": "Virée sauvage",
    "desc": "Peut être utilisé comme monture pour se déplacer un peu plus rapidement."
  },
  "BerryGoat": {
    "title": "Cueillette de baies",
    "desc": "À affecter à une Ferme pour faire pousser des Baie rouge sur son dos."
  },
  "BerryGoat_Dark": {
    "title": "Cueillette de baies",
    "desc": "À affecter à une Ferme pour faire pousser des Baie rouge sur son dos."
  },
  "MopBaby": {
    "title": "Gouzi-gouzi",
    "desc": "Le statut de Sweepa augmente lorsqu'il est dans l'équipe."
  },
  "MopKing": {
    "title": "Gouzi-gouzi royal",
    "desc": "Peut être utilisé comme monture pour se déplacer. En combattant à ses côtés, son statut augmente proportionnellement\r\nau nombre de Swee dans l'équipe."
  },
  "TentacleTurtle": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "TentacleTurtle_Ground": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "WindChimes": {
    "title": "Trapéziste",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Emmène le joueur plus haut dans les airs."
  },
  "WindChimes_Ice": {
    "title": "Trapéziste du froid",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Emmène le joueur plus haut dans les airs."
  },
  "SweetsSheep": {
    "title": "Petit bonbon",
    "desc": "À affecter à une Ferme pour obtenir des Barbe à papas."
  },
  "SweetsSheep_Ground": {
    "title": "Petit bonbon",
    "desc": "À affecter à une Ferme pour obtenir des Barbe à papas."
  },
  "CowPal": {
    "title": "Production de lait",
    "desc": "À affecter à une Ferme pour lui faire produire du Lait."
  },
  "BlueDragon": {
    "title": "Danse de l'eau",
    "desc": "Peut être utilisé comme monture pour nager. Confère le type Eau\r\naux attaques du joueur lorsqu'il est monté."
  },
  "BlueDragon_Ice": {
    "title": "Danse de l'eau",
    "desc": "Peut être utilisé comme monture pour nager. Confère le type Eau\r\naux attaques du joueur lorsqu'il est monté."
  },
  "ElecCat": {
    "title": "Électricité statique",
    "desc": "Augmente l'attaque des Pals de type Électricité lorsqu'il est dans l'équipe."
  },
  "Kelpie": {
    "title": "Jet d'eau",
    "desc": "Augmente l'attaque des Pals de type Eau lorsqu'il est dans l'équipe."
  },
  "Kelpie_Fire": {
    "title": "Jet de lave",
    "desc": "Augmente l'attaque des Pals de type Feu lorsqu'il est dans l'équipe."
  },
  "PinkRabbit": {
    "title": "Pattes adroites",
    "desc": "Augmente l'attaque des Pals de type Non élém. lorsqu'il est dans l'équipe. Accroît la production lorsqu'il travaille\r\ndans une Établi pour armes sur le camp."
  },
  "PinkRabbit_Grass": {
    "title": "Pattes adroites",
    "desc": "Augmente l'attaque des Pals de type Non élém. lorsqu'il est dans l'équipe. Accroît la production lorsqu'il travaille\r\ndans une Établi pour armes sur le camp."
  },
  "JellyfishFairy": {
    "title": "Largue-Jelliette",
    "desc": "Lorsqu'il est dans l'équipe, augmente de 55~95% la quantité d'objets obtenus à la pêche. (Effet non cumulable)\nDe plus, lorsque Jelliette et Jellroy se trouvent dans la base, la vitesse de travail d'arrosage de Jelliette augmente de 50~120%. (Effet non cumulable)"
  },
  "JellyfishGhost": {
    "title": "Largue-Jellroy",
    "desc": "Lorsqu'il est dans l'équipe, augmente de 55~95% la quantité d'objets obtenus par récupération. (Effet non cumulable)\nDe plus, lorsque Jelliette et Jellroy se trouvent dans la base, la vitesse de travail d'arrosage de Jellroy augmente de 50~120%. (Effet non cumulable)"
  },
  "ClioneTwins": {
    "title": "Jumelage Magique",
    "desc": "Dans la base, le niveau de la capacité de travail Arrosage des autres Pals du camp augmente de +1. (Effet non cumulable)"
  },
  "OctopusGirl": {
    "title": "Tapette Princière",
    "desc": "Lorsqu'il est dans l'équipe, réduit de 12~35% la diminution de la jauge de capture lorsque les barres ne sont pas superposées dans le mini-jeu de pêche. (Effet non cumulable)"
  },
  "OctopusGirl_Neutral": {
    "title": "Princesse Ventouse",
    "desc": "Lorsqu'il est dans l'équipe, augmente la défense des Pals de type Eau de 15~30 %. (Effet non cumulable)"
  },
  "Eagle": {
    "title": "Monte-Galeclaw",
    "desc": "Peut être appelé à la place du planeur lorsqu'il est dans l'équipe. Permet de garder la main droite libre pour tirer en plein vol."
  },
  "GhostBlackCat": {
    "title": "Félin Possédé",
    "desc": "Lorsqu’il est dans l’équipe, augmente les chances de capture des Pals lors du bonus d’attaque par derrière. (Effet non cumulable)"
  },
  "HawkBird": {
    "title": "Compagnon de voyage",
    "desc": "Peut être utilisé comme monture pour voler."
  },
  "CatBat": {
    "title": "Capteur à ultrasons",
    "desc": "Détecte les Pals à proximité grâce à des ultrasons lorsqu'il est appelé."
  },
  "ColorfulBird": {
    "title": "Lance-œufs explosifs",
    "desc": "S'équipe sur le joueur lorsqu'il est appelé pour faire office de lance-œufs explosifs."
  },
  "Kirin": {
    "title": "Éclair foudroyant",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Électricité aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "Kirin_Ice": {
    "title": "Éclair foudroyant",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Électricité aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "SharkKid": {
    "title": "Squale ronchon",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Tir aquatique.\r\nL'attaque du joueur augmente lorsqu'il est dans l'équipe."
  },
  "SharkKid_Fire": {
    "title": "Squale ronchon",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Fente enflammée.\r\nL'attaque du joueur augmente lorsqu'il est dans l'équipe."
  },
  "Werewolf": {
    "title": "Grilles scintillantes",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Griffe sautée."
  },
  "Werewolf_Ice": {
    "title": "Grilles scintillantes",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Griffe sautée."
  },
  "DarkCrow": {
    "title": "Picorage intense",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Assaut fantôme."
  },
  "FlameBuffalo": {
    "title": "Chaleur corporelle",
    "desc": "Peut être utilisé comme monture pour se déplacer. La chaleur sur son dos protège du froid lorsqu'il est monté."
  },
  "FluffyBird": {
    "title": "Tourontoudou",
    "desc": "Lorsqu'il est dans l'équipe, augmente les chances de capturer les Pals affectés par Gel. (Effet non cumulable)"
  },
  "LittleBriarRose": {
    "title": "Regard de princesse",
    "desc": "Augmente l'attaque des Pals de type Herbe lorsqu'il est dans l'équipe."
  },
  "CuteButterfly": {
    "title": "Écailles mystérieuses",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Nuage toxique."
  },
  "ElecPomeranian": {
    "title": "Poussée Crépitante",
    "desc": "Dans la base, le niveau de la compétence de travail Génération d'énergie des autres Pals du camp augmente de 1. (Effet non cumulable)"
  },
  "FairyDragon": {
    "title": "Dragon sacré au grand cœur",
    "desc": "Peut être utilisé comme monture pour voler. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Ténèbres est vaincu."
  },
  "FairyDragon_Water": {
    "title": "Dragon aquatique au grand cœur",
    "desc": "Peut être utilisé comme monture pour voler. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Feu est vaincu."
  },
  "BirdDragon": {
    "title": "Assaillant céleste",
    "desc": "Peut être utilisé comme monture pour voler. Si un point faible ennemi est touché lorsqu'il est monté,\r\nles dégâts infligés sont accrus."
  },
  "BirdDragon_Ice": {
    "title": "Assaillant céleste",
    "desc": "Peut être utilisé comme monture pour voler. Si un point faible ennemi est touché lorsqu'il est monté,\r\nles dégâts infligés sont accrus."
  },
  "CatVampire": {
    "title": "Vol de vie",
    "desc": "En combattant à ses côtés, absorbe une partie des dégâts infligés par le joueur pour restaurer\r\nses PV ainsi que ceux du joueur."
  },
  "VioletFairy": {
    "title": "Purification tellurique",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Terre est vaincu."
  },
  "SoldierBee": {
    "title": "Abeille ouvrière",
    "desc": "À affecter à une Ferme pour lui faire produire du Miel.\r\nLe statut de Elizabee augmente lorsqu'il est dans l'équipe."
  },
  "QueenBee": {
    "title": "Reine des abeilles",
    "desc": "En combattant à ses côtés, son statut augmente proportionnellement au nombre de Beegarde dans l'équipe."
  },
  "PinkLizard": {
    "title": "Draine-cœur",
    "desc": "En combattant à ses côtés, absorbe une partie des dégâts infligés par le joueur pour restaurer\r\nses PV ainsi que ceux du joueur."
  },
  "NaughtyCat": {
    "title": "Corps dodu",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Non élém. sont renforcées lorsqu'il est monté."
  },
  "PurpleSpider": {
    "title": "Toile de Tarantriss",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet d'effectuer un double saut lorsqu'il est monté.\nPermet également de projeter une toile vers un point ciblé afin de s'y déplacer rapidement à l'aide d'un grappin."
  },
  "IceSeal": {
    "title": "Dévale Montagne",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLa vitesse de déplacement augmente de 80~160% sur la neige.\nPermet également de dévaler les pentes à toute vitesse."
  },
  "IceSeal_Ground": {
    "title": "Dévale-Montagne",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nAugmente de 80~160 % la vitesse de déplacement sur la neige.\nPermet également de dévaler les pentes à grande vitesse.\nLors des glissades, la vitesse de départ est faible, mais la vitesse maximale est élevée."
  },
  "LizardMan": {
    "title": "Intuition",
    "desc": "Active son sixième sens lorsqu'il est appelé pour détecter les donjons à proximité."
  },
  "LizardMan_Fire": {
    "title": "Intuition",
    "desc": "Active son sixième sens lorsqu'il est appelé pour détecter les donjons à proximité."
  },
  "Gorilla": {
    "title": "Mode enragé",
    "desc": "Déchaîne toute sa sauvagerie lorsqu'il est appelé pour augmenter temporairement son attaque."
  },
  "Gorilla_Ground": {
    "title": "Mode enragé",
    "desc": "Déchaîne toute sa sauvagerie lorsqu'il est appelé pour augmenter temporairement son attaque."
  },
  "Serpent": {
    "title": "Fouisseur furtif",
    "desc": "Peut être utilisé comme monture pour nager. Lorsqu'il est monté, l'endurance ne descend plus\r\npendant les déplacements aquatiques."
  },
  "Serpent_Ground": {
    "title": "Fouisseur édaphique",
    "desc": "Peut être utilisé comme monture pour se déplacer."
  },
  "RobinHood": {
    "title": "Œil de faucon",
    "desc": "En combattant à ses côtés, augmente les dégâts infligés par le joueur lorsqu'il attaque un point faible."
  },
  "RobinHood_Ground": {
    "title": "Œil de faucon",
    "desc": "En combattant à ses côtés, les dégâts sur les points faibles qu'inflige le joueur aux ennemis augmentent."
  },
  "FlowerRabbit": {
    "title": "Lapin serviable",
    "desc": "Apparaît aux côtés du joueur lorsqu'il est dans l'équipe pour ramasser automatiquement les objets à proximité."
  },
  "FoxMage": {
    "title": "Maître renard",
    "desc": "En combattant à ses côtés, confère le type Feu aux attaques du joueur."
  },
  "FoxMage_Dark": {
    "title": "Maître renard",
    "desc": "En combattant à ses côtés, confère le type Feu aux attaques du joueur."
  },
  "CatMage": {
    "title": "Chat de bibliothèque",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente\r\nsi un Pal de type Non élém. est vaincu."
  },
  "CatMage_Fire": {
    "title": "Chat de bibliothèque",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente\r\nsi un Pal de type Non élém. est vaincu."
  },
  "HadesBird": {
    "title": "Ailes des enfers",
    "desc": "Peut être utilisé comme monture pour voler. Confère le type Ténèbres aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "HadesBird_Electric": {
    "title": "Ailes des enfers",
    "desc": "Peut être utilisé comme monture pour voler. Confère le type Ténèbres aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "GrassMinotaur": {
    "title": "Menace Naturelle",
    "desc": "Lorsqu’il est activé, Elgrove transfère son pouvoir au joueur, convertissant ses attaques en Herbe et augmentant son attaque de 30~50 %."
  },
  "GrassMinotaur_Ice": {
    "title": "Pergélisol Menaçant",
    "desc": "Lorsqu’il est dans l’équipe, lorsqu’un ennemi affecté par Trempé est attaqué par le joueur, il est immédiatement affecté par Gel."
  },
  "Mutant": {
    "title": "Antigravité",
    "desc": "Utilise ses pouvoirs antigravité lorsqu'il est dans l'équipe pour augmenter le poids max du joueur."
  },
  "FengyunDeeper": {
    "title": "Vent et nuages",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut lorsqu'il est monté."
  },
  "FengyunDeeper_Electric": {
    "title": "Vent et nuages",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut lorsqu'il est monté."
  },
  "FlowerDinosaur": {
    "title": "Dragon fleurissant",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Herbe sont renforcées lorsqu'il est monté."
  },
  "FlowerDinosaur_Electric": {
    "title": "Dragon orageux",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Électricité sont renforcées lorsqu'il est monté."
  },
  "Ronin": {
    "title": "Flash furtif",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Iaigiri."
  },
  "Ronin_Dark": {
    "title": "Flash furtif",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Iaigiri."
  },
  "IceCrocodile": {
    "title": "Entrailles Glacées",
    "desc": "Lorsqu'il est dans l'équipe, réduit de 30~60% le poids des ingrédients et des plats.\n\nDe plus, les aliments se détériorent -80~-30% plus lentement, en complément de l'effet de conservation déjà conféré par les Pals de type Glace. (Effet non cumulable)"
  },
  "GrassMammoth": {
    "title": "Broyeur tellurique",
    "desc": "Peut être utilisé comme monture pour se déplacer. Le bois et le minerai se brisent plus facilement lorsqu'il est monté."
  },
  "GrassMammoth_Ice": {
    "title": "Broyeur à glace",
    "desc": "Peut être utilisé comme monture pour se déplacer. Le bois et le minerai se brisent plus facilement lorsqu'il est monté."
  },
  "StuffedShark": {
    "title": "Aqua-Gâchette",
    "desc": "Lorsqu’activé, Finsider transfère son pouvoir au joueur, convertissant ses attaques en Eau et augmentant son attaque de 30~50 %."
  },
  "StuffedShark_Fire": {
    "title": "Chambre de Braises",
    "desc": "Lorsqu'il est dans l'équipe, Finsider Ignis porte les affaires du joueur et réduit de 60~100% le poids des armes dans l'inventaire.\nAugmente également de 25~40% les dégâts de type Feu infligés aux points faibles. (effet non cumulable)"
  },
  "FlowerDoll": {
    "title": "Bénédiction florale",
    "desc": "Restaure les PV du joueur grâce au pouvoir curatif des fleurs lorsqu'il est appelé."
  },
  "FlowerDoll_Fire": {
    "title": "Bénédiction florale",
    "desc": "Restaure les PV du joueur grâce au pouvoir curatif des fleurs lorsqu'il est appelé."
  },
  "PandaGirl": {
    "title": "Abnégation",
    "desc": "L'attaque et la défense de ce Pal augmentent de 2~6% pour chaque Pal de type Herbe présent dans l'équipe, à l'exception de Leafan."
  },
  "Baphomet": {
    "title": "Chasseur aux griffes ardentes",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Griffe infernale."
  },
  "Baphomet_Dark": {
    "title": "Chasseur aux griffes noires",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence Griffe infernale."
  },
  "RaijinDaughter": {
    "title": "Fille de la foudre",
    "desc": "Apparaît aux côtés du joueur lorsqu'il est dans l'équipe pour accompagner ses attaques avec des coups de tonnerre."
  },
  "RaijinDaughter_Water": {
    "title": "Fille de la foudre",
    "desc": "Apparaît aux côtés du joueur lorsqu'il est dans l'équipe pour accompagner ses attaques avec des coups de tonnerre."
  },
  "FireKirin": {
    "title": "Cheval rouge",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Feu\r\naux attaques du joueur lorsqu'il est monté."
  },
  "FireKirin_Dark": {
    "title": "Cheval noir",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Ténèbres\r\naux attaques du joueur lorsqu'il est monté."
  },
  "LazyDragon": {
    "title": "Missile affamé",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du tir rapide au lance-missiles lorsqu'il est monté."
  },
  "LazyDragon_Electric": {
    "title": "Fête aux missiles",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du tir rapide au lance-missiles lorsqu'il est monté."
  },
  "IceFox": {
    "title": "Instinct boréal",
    "desc": "Augmente l'attaque des Pals de type Glace lorsqu'il est dans l'équipe."
  },
  "ThunderBird": {
    "title": "Orage",
    "desc": "Peut être utilisé comme monture pour voler. Lorsqu'il est monté, confère le type Électricité aux attaques\r\ndu joueur."
  },
  "ThunderBird_Ice": {
    "title": "Orage",
    "desc": "Peut être utilisé comme monture pour voler. Lorsqu'il est monté, confère le type Électricité aux attaques\r\ndu joueur."
  },
  "GhostAnglerfish": {
    "title": "Guide des Ténèbres",
    "desc": "Peut être utilisé comme monture pour se déplacer sur l'eau.\nLa vitesse de déplacement de ce Pal augmente de 5~25% pour chaque Pal de type Ténèbres ou Eau présent dans l'équipe, à l'exception de Ghangler."
  },
  "GhostAnglerfish_Fire": {
    "title": "Cordon-bleu des Profondeurs",
    "desc": "Peut être utilisé comme monture pour nager.\nLa vitesse de déplacement de ce Pal augmente de 5~25% pour chaque Pal de type Feu ou Eau présent dans l'équipe, à l'exception de Ghangler Ignis."
  },
  "ThunderDog": {
    "title": "Sauteur fou",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut lorsqu'il est monté."
  },
  "ThunderDog_Ice": {
    "title": "Sauteur fou",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut lorsqu'il est monté."
  },
  "DarkScorpion": {
    "title": "Scorpion d'acier",
    "desc": "En combattant à ses côtés, augmente la défense du joueur et si un Pal de type Électricité est vaincu,\r\nle nombre d'objets obtenus augmente également."
  },
  "DarkScorpion_Ground": {
    "title": "Scorpion d'acier",
    "desc": "En combattant à ses côtés, augmente la défense du joueur et si un Pal de type Électricité est vaincu,\r\nle nombre d'objets obtenus augmente également."
  },
  "CactusDoll": {
    "title": "Free Hug",
    "desc": "Augmente de 50~65 % les dégâts infligés par le joueur et les Pals aux ennemis affectés par l'état Entrave lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "CactusDoll_Dark": {
    "title": "Câlin Piquant",
    "desc": "Lorsqu'il est dans l'équipe, ajoute une valeur d’accumulation d’état Entrave de 2~6 aux attaques du joueur. (Effet non cumulable)"
  },
  "IceDeer": {
    "title": "Fraîcheur corporelle",
    "desc": "Peut être utilisé comme monture pour se déplacer. La fraîcheur sur son dos protège de la chaleur lorsqu'il est monté."
  },
  "GrassPanda": {
    "title": "Pandanade",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du tir rapide au lance-grenades lorsqu'il est monté."
  },
  "GrassPanda_Electric": {
    "title": "Pandanade",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du tir rapide au lance-grenades lorsqu'il est monté."
  },
  "WeaselDragon": {
    "title": "Belette stupéfiante",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Dragon aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "WeaselDragon_Fire": {
    "title": "Belette stupéfiante",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Dragon aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "RedArmorBird": {
    "title": "Ailes enflammées",
    "desc": "Peut être utilisé comme monture pour voler. Confère le type Feu aux attaques\r\ndu joueur lorsqu'il est monté."
  },
  "VolcanoDragon": {
    "title": "Trop-Plein de Magma",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nL'attaque de ce Pal augmente de 4~8% pour chaque Pal de type Feu ou Terre présent dans l'équipe, à l'exception de Moldron."
  },
  "VolcanoDragon_Ice": {
    "title": "Trop-Plein de Glace",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nAugmente de 25~40 % les dégâts infligés par le joueur et les Pals lorsqu’ils exploitent la faiblesse d’un ennemi avec des attaques de type Glace. (Effet non cumulable)"
  },
  "TropicalOstrich": {
    "title": "Bain de Soleil",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLa vitesse de déplacement augmente de 155~240% dans les hautes herbes."
  },
  "DrillGame": {
    "title": "Perceuse broyeuse",
    "desc": "Utilise Coquille rotative lorsqu'il est appelé. Suit le joueur en tournoyant pour\r\nbriser plus facilement les minerais."
  },
  "SakuraSaurus": {
    "title": "Excès d'amour",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "SakuraSaurus_Water": {
    "title": "Excès d'amour",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "LazyCatfish": {
    "title": "Amélioration terrestre",
    "desc": "Augmente l'attaque des Pals de type Terre lorsqu'il est dans l'équipe."
  },
  "LazyCatfish_Gold": {
    "title": "Amélioration terrestre",
    "desc": "Augmente l'attaque des Pals de type Terre lorsqu'il est dans l'équipe."
  },
  "Plesiosaur": {
    "title": "Soleil Accablant",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nDans la base, la vitesse de production des œufs des Pals affectés à un Élevage augmente de 20~50%. (Effet non cumulable)"
  },
  "AmaterasuWolf": {
    "title": "Vide-esprit",
    "desc": "Peut être utilisé comme monture pour se déplacer. Lorsqu'il est monté, le froid et la chaleur n'ont aucun effet."
  },
  "AmaterasuWolf_Dark": {
    "title": "Vide-esprit",
    "desc": "Peut être utilisé comme monture pour se déplacer. Lorsqu'il est monté, le froid et la chaleur n'ont aucun effet."
  },
  "Manticore": {
    "title": "Lion infernal",
    "desc": "Peut être utilisé comme monture pour se déplacer. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Herbe est vaincu."
  },
  "Manticore_Dark": {
    "title": "Lion des flammes noires",
    "desc": "Peut être utilisé comme monture pour se déplacer. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Non élém. est vaincu."
  },
  "HerculesBeetle": {
    "title": "Armure impénétrable",
    "desc": "En combattant à ses côtés, augmente la défense du joueur et réduit les dégâts de type Feu encaissés."
  },
  "HerculesBeetle_Ground": {
    "title": "Armure impénétrable",
    "desc": "En combattant à ses côtés, augmente la défense du joueur et réduit les dégâts de type Feu encaissés."
  },
  "SnowPeafowl": {
    "title": "Paon Pan",
    "desc": "Tant qu'il est dans l'équipe, l'air froid de Frostplume améliore la concentration du joueur et augmente sa vitesse de recharge de +20~50 %. (Non cumulable)"
  },
  "DarkFlameFox": {
    "title": "Incantation Secrète",
    "desc": "Lorsqu'il est dans l'équipe et qu'une attaque du joueur touche un ennemi affecté par Brûlure, des flammes apparaissent autour de l’ennemi et les ennemis en contact subissent des dégâts continus équivalents à 15~30 % de l’attaque du joueur. (Effet non cumulable)"
  },
  "WhiteMoth": {
    "title": "Ver à soie",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence {active-skill-missing}.\r\nÀ affecter à une Ferme\r\npour lui faire fabriquer du Tissu de qualité."
  },
  "WhiteMoth_Neutral": {
    "title": "Ver à soie",
    "desc": "Se tourne vers l'ennemi visé lorsqu'il est appelé pour l'attaquer avec la puissante compétence {active-skill-missing}.\r\nÀ affecter à une Ferme\r\npour lui faire fabriquer du Tissu de qualité."
  },
  "GhostBeast": {
    "title": "Messager infernal",
    "desc": "Peut être utilisé comme monture pour se déplacer. Confère le type Ténèbres\r\naux attaques du joueur lorsqu'il est monté."
  },
  "MushroomDragon": {
    "title": "Spores Vivaces",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPeut être assigné à une Exploitation avec une chance de produire un Champignon ou un Champignon des cavernes."
  },
  "MushroomDragon_Dark": {
    "title": "Spores Fumantes",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nDans la base, les mystérieuses spores de Shroomer Noct ralentissent la diminution des points MEN des Pals de 10~15%."
  },
  "IceWitch": {
    "title": "Sorcière Frigorifique",
    "desc": "Lorsqu’activé, Icelyn transfère son pouvoir au joueur, convertissant ses attaques en Glace et augmentant son attaque de 30~50 %."
  },
  "MummyPal": {
    "title": "Résurrection",
    "desc": "Lorsqu'il combat à vos côtés, si Gildra est mis K.O., il est ressuscité au prix d'une satiété réduite à 0."
  },
  "Umihebi": {
    "title": "Dragon des mers tempétueux",
    "desc": "Peut être utilisé comme monture pour nager. Lorsqu'il est monté, l'endurance ne descend plus\r\npendant les déplacements aquatiques."
  },
  "Umihebi_Fire": {
    "title": "Dragon des laves tempétueux",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Feu sont renforcées lorsqu'il est monté."
  },
  "Suzaku": {
    "title": "Ailes de feu",
    "desc": "Peut être utilisé comme monture pour voler. Les attaques de type Feu sont renforcées lorsqu'il est monté."
  },
  "Suzaku_Water": {
    "title": "Ailes d'eau",
    "desc": "Peut être utilisé comme monture pour voler. Les attaques de type Eau sont renforcées lorsqu'il est monté."
  },
  "FeatherOstrich": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "SkyDragon": {
    "title": "Compassion du dragon céleste",
    "desc": "Peut être utilisé comme monture pour voler. Les attaques de type Dragon sont renforcées lorsqu'il est monté."
  },
  "SkyDragon_Grass": {
    "title": "Compassion du dragon céleste",
    "desc": "Peut être utilisé comme monture pour voler. Les attaques de type Dragon sont renforcées lorsqu'il est monté."
  },
  "LeafPrincess": {
    "title": "Turbo Floral",
    "desc": "Dans la base, Lullu insuffle de l'énergie aux plantations pour augmenter la vitesse de croissance des cultures de 50~70%."
  },
  "SmallArmadillo": {
    "title": "Balle de Plage",
    "desc": "Lorsqu’il est dans l’équipe, augmente la défense des Pals de type Terre de 15~30%. (Effet non cumulable)"
  },
  "GuardianDog": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "SwordCutlassfish": {
    "title": "Désossage",
    "desc": "Lorsqu'activée, Skutlass se transforme en katana à disposition du joueur (Attaque : 2600~3900).\nS'il ne retrouve pas rapidement sa forme d'origine, Skutlass tombe K.O.\nUtiliser une attaque Laigiri le met également K.O."
  },
  "SwordCutlassfish_Fire": {
    "title": "Barbecue",
    "desc": "Lorsqu'activée, Skutlass Ignis se transforme en katana à disposition du joueur (Attaque : 2900~4200).\nS'il ne retrouve pas rapidement sa forme d'origine, Skutlass Ignis tombe K.O.\nUtiliser une attaque Laigiri le met également K.O."
  },
  "VolcanicMonster": {
    "title": "Bête briseuse de cristal",
    "desc": "Peut être utilisé comme monture pour se déplacer. Le minerai se brise plus facilement lorsqu'il est monté."
  },
  "VolcanicMonster_Ice": {
    "title": "Bête briseuse d'icebergs",
    "desc": "Peut être utilisé comme monture pour se déplacer. Le minerai se brise plus facilement lorsqu'il est monté."
  },
  "NightBlueHorse": {
    "title": "Danseur de Minuit",
    "desc": "Peut être chevauché pour se déplacer. Augmente la hauteur des sauts lorsque vous êtes en selle.\nLa nuit, la vitesse de déplacement de ce Pal augmente de +50~100 %."
  },
  "NightBlueHorse_Neutral": {
    "title": "Danseur Radieux",
    "desc": "Peut être utilisé comme monture pour se déplacer et permet de sauter plus haut une fois monté.\nLa vitesse de déplacement de ce Pal augmente de 5~25 % pour chaque Pal de type Non élém. présent dans l'équipe, à l'exception de Starryon Primo."
  },
  "RockBeast": {
    "title": "Pierre de Force",
    "desc": "Augmente de 50~65 % les dégâts infligés par le joueur et les Pals aux ennemis affectés par l'état Embourbement lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "RockBeast_Ice": {
    "title": "Cristal de Force",
    "desc": "Lorsqu'il est dans l'équipe, réduit de 15~30% les dégâts de type Dragon subis par le joueur et les Pals. (Effet non cumulable)"
  },
  "WhiteTiger": {
    "title": "Chasseur de dragons",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Dragon est vaincu."
  },
  "WhiteTiger_Ground": {
    "title": "Chasseur de dragons",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Dragon est vaincu."
  },
  "SmallYeti": {
    "title": "Œil Invisible",
    "desc": "Lorsqu’il est dans l’équipe, réduit la probabilité d’être repéré par les ennemis. (Effet non cumulable)"
  },
  "Yeti": {
    "title": "Colosse des neiges",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "Yeti_Grass": {
    "title": "Colosse du Sud",
    "desc": "Peut être utilisé comme monture pour se déplacer. Porte les affaires du joueur lorsqu'il est dans l'équipe\r\npour augmenter son poids max."
  },
  "CandleGhost": {
    "title": "Pille-Tombes",
    "desc": "Lorsqu’il est dans l’équipe, réduit de 15~30% les dégâts de type Non élém. subis par le joueur et les Pals. (Effet non cumulable)\nPeut être assigné à une Exploitation avec une chance de déterrer des Os."
  },
  "VenusFlytrap": {
    "title": "Langue Fourchue",
    "desc": "Lorsqu'il est dans l'équipe et que le joueur effectue une roulade ou des déplacements rapides, Carnibora génère une tornade qui inflige des dégâts aux ennemis touchés (Herbe / Puissance : 40~80). (Effet non cumulable)"
  },
  "KingBahamut": {
    "title": "Empereur magmatique",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Feu sont renforcées lorsqu'il est monté."
  },
  "KingBahamut_Dragon": {
    "title": "Empereur magmatique",
    "desc": "Peut être utilisé comme monture pour se déplacer. Les attaques de type Feu sont renforcées lorsqu'il est monté."
  },
  "GrassGolem": {
    "title": "Laser Sylvain",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLorsqu'activée, Dualith projette un puissant laser de type Herbe depuis sa main droite."
  },
  "GrassGolem_Dark": {
    "title": "Laser Corrompu",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLorsqu'activée, Dualith Noct projette un puissant laser de type Ténèbres depuis sa main droite."
  },
  "Anubis": {
    "title": "Gardien du désert",
    "desc": "En combattant à ses côtés, confère le type Terre aux attaques du joueur.\r\nSes pas rapides lui permettent parfois d'esquiver les attaques."
  },
  "Sekhmet": {
    "title": "Impératrice des Sables",
    "desc": "Dans la base, la vitesse de travail des Anubis présents augmente de 20~40 %. (Effet non cumulable)\nL'efficacité de travail de Sekhmet augmente de 30~60 % lorsqu'il travaille sur un établi ou dans une usine."
  },
  "ScorpionMan": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "ScorpionMan_Electric": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "CubeTurtle": {
    "title": "Tortue Maçonne",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLorsqu’il est dans la base, augmente le niveau de la capacité de travail Extraction des autres Pals de la base de 1. (Effet non cumulable)"
  },
  "CubeTurtle_Neutral": {
    "title": "Tortue Madone",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nRéduit de 80~100 % la perte de durabilité des armes et des armures lorsqu’il est dans l’équipe. (Effet non cumulable)"
  },
  "BadCatgirl": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "MimicDog": {
    "title": "Crochetage",
    "desc": "Lorsqu'il combat à vos côtés, le pouvoir de Mimog permet d'ouvrir les coffres sans utiliser de clé."
  },
  "DarkAlien": {
    "title": "Envahisseur Non Identifié",
    "desc": "Lorsqu’il est dans l’équipe, les dégâts infligés par la dernière balle du chargeur des armes automatiques augmentent de 100~160%. (Effet non cumulable)"
  },
  "WhiteAlienDragon": {
    "title": "Intrus Non Identifié",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLorsqu’il est dans l’équipe, augmente de 10~35% les dégâts infligés par les armes énergétiques du joueur. (Effet non cumulable)"
  },
  "BlueberryFairy": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "GhostRabbit": {
    "title": "Lapin Volâme",
    "desc": "Lorsqu’il est dans l’équipe, augmente de +100~200% la quantité d’âmes obtenues en terrassant des Pals. (Effet non cumulable)"
  },
  "GhostRabbit_Grass": {
    "title": "Lapin Blokâme",
    "desc": "Lorsqu'il est dans l'équipe, augmente la défense des Pals de type Herbe de 15~30%. (Effet non cumulable)"
  },
  "BlackPuppy": {
    "title": "Chien fidèle Smokie",
    "desc": "Lorsqu'activée, son odorat très développé permet de détecter le Chromite à proximité.\nLorsqu'il combat à vos côtés, la quantité de Chromite obtenue augmente de +100~200%."
  },
  "BlackPuppy_Ice": {
    "title": "Froide Bête",
    "desc": "Dans la base, le niveau de la capacité de travail Réfrigération des autres Pals du camp augmente de +1. (Effet non cumulable)"
  },
  "MysteryMask": {
    "title": "Danse du Masque",
    "desc": "Lorsqu'il est dans l'équipe, augmente la quantité d'EXP obtenue par les Pals de l'équipe de 40~80%. (effet non cumulable)"
  },
  "IceNarwhal": {
    "title": "Céta-Frais",
    "desc": "Peut être utilisé comme monture pour se déplacer sur l'eau.\nLorsqu'il est dans l'équipe, les mini-jeux de pêche commencent avec une jauge de capture remplie de 5~14% supplémentaires, et la progression de la jauge augmente de 5~14% lorsque les barres sont superposées. (Effet non cumulable)"
  },
  "IceNarwhal_Fire": {
    "title": "Céta-Chaud",
    "desc": "Peut être utilisé comme monture pour nager.\nLorsqu'il est dans l'équipe, les mini-jeux de pêche commencent avec une jauge de capture remplie à 7~17% supplémentaires, et la jauge progresse de 7~17% supplémentaires lorsque les barres se chevauchent. (effet non cumulable)"
  },
  "GrassRabbitMan": {
    "title": "Fusée des plaines",
    "desc": "En combattant à ses côtés, augmente la vitesse de déplacement et confère le type Herbe aux attaques du joueur."
  },
  "GrimGirl": {
    "title": "Lame Amoureuse",
    "desc": "Lorsqu'il est dans l'équipe, augmente de 100~200% les objets obtenus lors du dépeçage avec un Couteau de boucher. (effet non cumulable)"
  },
  "GoldenHorse": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "SifuDog": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "SumoDog": {
    "title": "Carrure de Champion",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nRéduit de 15~30 % les dégâts de type Électricité subis par le joueur et les Pals, et annule l'état Électrisation lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "WhiteDeer": {
    "title": "Bénédiction Purificatrice",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nL'attaque et la vitesse de déplacement de ce Pal augmentent de 2~6% pour chaque Pal de type Non élém. présent dans l'équipe, à l'exception de Celesdir.\nLorsqu'il est dans l'équipe, restaure chaque seconde les PV du joueur et des Pals de l'équipe de 0.15~0.75% en dehors des combats. (Effet non cumulable)"
  },
  "WhiteDeer_Dark": {
    "title": "Bénédiction du Chaos",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nAugmente l’attaque des Pals en combat de 40~80 % lorsqu’il est dans l’équipe, mais leurs PV diminuent progressivement. (Effet non cumulable)"
  },
  "BlackMetalDragon": {
    "title": "Dragon en armure noire",
    "desc": "Peut être utilisé comme monture pour voler. Lorsqu'il est monté, les dégâts infligés aux minerais sont accrus."
  },
  "WingGolem": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "WingGolem_Fire": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "WhiteShieldDragon": {
    "title": "Bouclier Aegis",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nLorsqu’il est dans l’équipe, réduit de 30~60% le délai avant le début de la régénération du bouclier du joueur et réduit de 65~80% la perte de durabilité du bouclier. (Effet non cumulable)"
  },
  "BlueThunderHorse": {
    "title": "Charge Plasma",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet également d'effectuer une ruée aérienne pour se déplacer à grande vitesse."
  },
  "LongCat": {
    "title": "Extensibilité Féline",
    "desc": "Lorsqu’il est dans l’équipe, la gravité affectant le joueur est réduite, rendant les sauts et les chutes plus légers. (Effet non cumulable)"
  },
  "ElecSnail": {
    "title": "Batterie Dissuasive",
    "desc": "Lorsqu'il est dans l'équipe, ajoute une valeur d’accumulation d’état Électrisation de 2~6 aux attaques du joueur. (Effet non cumulable)"
  },
  "ElecSnail_Ground": {
    "title": "Coquille Invasive",
    "desc": "Lorsqu'il est dans l'équipe, réduit de 15~30 % les dégâts de type Eau subis par le joueur et les Pals, et immunise contre Trempé. (Effet non cumulable)"
  },
  "DandelionGirl": {
    "title": "Fée Duveteuse",
    "desc": "Augmente le taux de capture des Pals souffrant de Entrave lorsqu’il est dans l’équipe. (Effet non cumulable)"
  },
  "BrownRabbit": {
    "title": "fr_Text",
    "desc": "fr_Text"
  },
  "HoodGhost": {
    "title": "Rôdeur du Néant",
    "desc": "Lorsqu'il est dans l'équipe, les dégâts infligés par le joueur aux ennemis hors combat augmentent de 50~100 %. (Effet non cumulable)"
  },
  "ElecLizard": {
    "title": "Mode Relax",
    "desc": "Lorsqu'il est dans l'équipe et qu'une attaque du joueur touche un ennemi affecté par Électrisation, celui-ci libère de l’électricité et inflige des dégâts aux ennemis proches équivalents à 40~60 % de l’attaque du joueur. (Effet non cumulable)"
  },
  "OniGhostGirl": {
    "title": "Fantômette Joviale",
    "desc": "Réduit de 40~80 % l’attaque des ennemis affectés par Empoisonnement lorsqu’il est dans l’équipe. (Effet non cumulable)"
  },
  "KingSunfish": {
    "title": "Môle Charismatique",
    "desc": "Peut être utilisé comme monture pour nager.\nAugmente les chances d’attraper des Pals à potentiel lorsqu’il est dans l’équipe."
  },
  "KingSunfish_Thunder": {
    "title": "Môle Plasmique",
    "desc": "Peut être utilisé comme monture pour nager.\nLorsqu’il est monté, les attaques du joueur sont converties en Électricité, et son attaque augmente de 5~20 %.\nDe plus, pêcher des Pals à potentiel devient plus facile lorsqu’il est dans l’équipe."
  },
  "SleeveRabbit": {
    "title": "Manches Longues Triomphantes",
    "desc": "Lorsqu'il est dans l'équipe, réduit de 10~50% le temps de recharge des compétences partenaires des autres Pals de l'équipe. (Effet non cumulable)"
  },
  "GhostDragon": {
    "title": "Ptérodactyle Libre",
    "desc": "Peut être utilisé comme monture pour voler.\n\nL'attaque et la vitesse de déplacement de ce Pal augmentent de 2~6 % pour chaque Pal de type Dragon ou Ténèbres présent dans l'équipe, à l'exception de Eidrolon."
  },
  "GhostDragon_Fire": {
    "title": "Ptérodactyle Furieux",
    "desc": "Peut être utilisé comme monture pour voler.\n\nL'attaque et la vitesse de déplacement de ce Pal augmentent de 2~6 % pour chaque Pal de type Dragon ou Feu présent dans l'équipe, à l'exception de Eidrolon Ignis."
  },
  "ThunderFluffyBird": {
    "title": "Couvaison Électromassante",
    "desc": "Peut être utilisé comme monture pour voler.\nLorsqu’il est dans la base, augmente la vitesse d’éclosion des œufs de 20~40 %. (Effet non cumulable)"
  },
  "RedFlowerBird": {
    "title": "Danse Florale",
    "desc": "Lorsqu’il est dans l’équipe, augmente de 15~30 % la durée d’invincibilité lors des roulades et des esquives du joueur. (Effet non cumulable)"
  },
  "FoxExorcist": {
    "title": "Avenir Brûlant",
    "desc": "Lorsqu'il est dans l'équipe et qu'une attaque du joueur touche un ennemi affecté par Brûlure, celui-ci explose et inflige des dégâts supplémentaires équivalents à 40~60 % de l'attaque du joueur. (Effet non cumulable)"
  },
  "LotusDragon": {
    "title": "Brume Glorieuse",
    "desc": "Lorsqu'il est dans l'équipe, ajoute 2~6 d'accumulation d'état Trempé aux attaques du joueur. (Effet non cumulable)"
  },
  "ClownRabbit": {
    "title": "Passe-casse",
    "desc": "Lorsqu'il est dans l'équipe, Dupin provoque une explosion autour du joueur lorsque ses PV tombent sous 50 % (Feu / Puissance : 100~200).\nDe plus, l'attaque du joueur augmente de 30~50% tant que ses PV sont inférieurs à 50 %. (Effet non cumulable)"
  },
  "ThiefBird": {
    "title": "Ailes des Ténèbres",
    "desc": "Peut être utilisé comme monture pour voler.\nAugmente de 50~65 % les dégâts infligés par le joueur et les Pals aux ennemis affectés par l'état Cécité lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "SnakeGirl": {
    "title": "Sagacité Reptilienne",
    "desc": "Lorsqu’il est dans l’équipe, ajoute 2~6 d’accumulation d’état Cécité aux attaques du joueur. (Effet non cumulable)"
  },
  "MushroomLady": {
    "title": "Spores Charmants",
    "desc": "Dans la base, le niveau d'aptitude au travail Pharmacie des autres Pals du camp augmente de +1. (Effet non cumulable)"
  },
  "LanternButler": {
    "title": "Lanterne Enchantée",
    "desc": "Lorsqu’il est dans l’équipe, les flèches tirées par le joueur explosent à l’impact et infligent des dégâts supplémentaires équivalents à 15~30 % des dégâts d’attaque du joueur. (Effet non cumulable)"
  },
  "MoonChild": {
    "title": "Énergie Noire Secrète",
    "desc": "Lorsqu'il est dans l'équipe, augmente la défense des Pals de type Ténèbres de 15~30%. (Effet non cumulable)"
  },
  "MonochromeQueen": {
    "title": "Princesse Indomptable",
    "desc": "Lorsqu'il est dans l'équipe, l'attaque du joueur augmente de 30~80 % si tous les Pals de l’équipe sont d’espèces différentes. (Effet non cumulable)"
  },
  "KabukiMan": {
    "title": "Scène de Combat",
    "desc": "Lorsqu’il est dans l’équipe, ajoute 2~6 d’accumulation d’état Brûlure aux attaques du joueur. (Effet non cumulable)"
  },
  "DomeArmorDragon": {
    "title": "Dragon Inébranlable",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nRéduit de 60~80 % les dégâts des attaques explosives subis par le joueur et les Pals, et immunise contre Étourdissement lorsqu'il est dans l'équipe. (Effet non cumulable)"
  },
  "ElecPanda": {
    "title": "Tank jaune",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du tir rapide avec le minigun lorsqu'il est monté."
  },
  "LilyQueen": {
    "title": "Déesse de la fertilité",
    "desc": "Restaure beaucoup de PV au joueur grâce aux pouvoirs curatifs de la reine lorsqu'il est appelé."
  },
  "LilyQueen_Dark": {
    "title": "Déesse de la pénombre",
    "desc": "Restaure beaucoup de PV au joueur grâce aux pouvoirs curatifs de la reine lorsqu'il est appelé."
  },
  "ThunderDragonMan": {
    "title": "Dragon tonitruant",
    "desc": "En combattant à ses côtés, le nombre d'objets obtenus augmente si un Pal de type Eau est vaincu."
  },
  "Horus": {
    "title": "Prédateur brûlant",
    "desc": "Peut être utilisé comme monture pour voler. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Glace est vaincu."
  },
  "Horus_Water": {
    "title": "Prédateur brûlant",
    "desc": "Peut être utilisé comme monture pour voler. En combattant à ses côtés, le nombre d'objets obtenus\r\naugmente si un Pal de type Glace est vaincu."
  },
  "BlackGriffon": {
    "title": "Gènes modifiés",
    "desc": "Peut être utilisé comme monture pour voler. Les attaques de type Ténèbres sont renforcées lorsqu'il est monté."
  },
  "MoonQueen": {
    "title": "Ténèbres Célestes",
    "desc": "Peut être utilisé comme monture pour voler.\nUne fois monté, les attaques de type Non élém. et Ténèbres sont renforcées de 15~30%."
  },
  "SnowTigerBeastman": {
    "title": "Écrasement Blizzard",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet d'attaquer avec un marteau de type Glace lorsqu'il est monté."
  },
  "BlueSkyDragon": {
    "title": "Souverain du Ciel d'Azur",
    "desc": "Peut être utilisé comme monture pour voler.\nL'attaque de ce Pal augmente de 4~8% pour chaque Pal de type Dragon présent dans l'équipe, à l'exception de Shaolong."
  },
  "Mothman": {
    "title": "Gardien des Spores",
    "desc": "Lorsqu’il est dans l’équipe, fait exploser les ennemis souffrant de Entrave attaqués par le joueur, et inflige des dégâts supplémentaires équivalents à 40~60 % de l’attaque du joueur. (Effet non cumulable)\nDe plus, le joueur et les Pals sont immunisés aux spores explosives de l’Arbre-Monde."
  },
  "FlowerPrince": {
    "title": "Gardien du Brouillard",
    "desc": "Lorsqu'activée, confère 2~6 de Empoisonnement aux attaques du joueur.\nLorsqu'il est dans l'équipe, le joueur et les Pals deviennent immunisés contre Empoisonnement et les gaz toxiques de la zone de l’Arbre-Monde sont neutralisés. (Effet non cumulable)"
  },
  "NightLady": {
    "title": "Pupille Cauchemardesque",
    "desc": "Lorsqu'activée, attaque l'ennemi ciblé avec Rayons Cauchemardesques.\nLa puissance de Rayons Cauchemardesques utilisée par ce Pal est multipliée par 1.1~2.5."
  },
  "NightLady_Dark": {
    "title": "Regard Cauchemardesque",
    "desc": "Lorsqu'activée, attaque l'ennemi ciblé avec Floraison Cauchemardesque.\nLa puissance de Floraison Cauchemardesque utilisée par ce Pal est multipliée par 1.1~2.5."
  },
  "DarkMechaDragon": {
    "title": "Ailes Météores",
    "desc": "Peut être utilisé comme monture pour voler.\nLorsqu’il est dans l’équipe, augmente de 20~50% les dégâts des compétences partenaires des Pals équipés d’une arme. (Effet non cumulable)"
  },
  "LegendDeer": {
    "title": "Barrière Sacrée",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de générer une barrière bloquant toutes les attaques lorsqu'il est monté.\nPermet également d'effectuer un triple saut."
  },
  "SaintCentaur": {
    "title": "Chevalier céleste",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du triple saut lorsqu'il est monté."
  },
  "BlackCentaur": {
    "title": "Chevalier noir abyssal",
    "desc": "Peut être utilisé comme monture pour se déplacer. Permet l'utilisation du double saut lorsqu'il est monté."
  },
  "IceHorse": {
    "title": "Pégase des glaces",
    "desc": "Peut être utilisé comme monture pour voler. Lorsqu'il est monté, confère le type Glace aux attaques du joueur et\r\nrenforce les attaques de type Glace."
  },
  "IceHorse_Dark": {
    "title": "Pégase noir",
    "desc": "Peut être utilisé comme monture pour voler. Lorsqu'il est monté, confère le type Ténèbres aux attaques du joueur et\r\nrenforce les attaques de type Ténèbres."
  },
  "PoseidonOrca": {
    "title": "Conquérant des Océans",
    "desc": "Tant qu'il combat activement aux côtés du joueur, il lance des lances d'eau de type Eau pour attaquer les ennemis hostiles.\nPeut être chevauché pour se déplacer sur l'eau.\nPermet d'effectuer de grands sauts à la surface de l'eau lorsque vous êtes en selle."
  },
  "JetDragon": {
    "title": "Missile aérien",
    "desc": "Peut être utilisé comme monture pour voler. Permet l'utilisation du tir rapide au lance-missiles lorsqu'il est monté."
  },
  "KingWhale": {
    "title": "Gardien des Échos",
    "desc": "Peut être utilisé comme monture pour voler.\nUn seul spécimen peut être invoqué dans la base.\nLorsqu’il est dans la base, il patrouille en permanence dans le ciel au-dessus de celle-ci et attaque les intrus depuis de très haut dans les airs."
  },
  "YakushimaBoss001": {
    "title": "Ruée de l’Œil de Cthulhu",
    "desc": "Lorsqu'activée, Œil de Cthulhu charge l'ennemi ciblé pour l'attaquer."
  },
  "YakushimaBoss001_Small": {
    "title": "Vision Démoniaque",
    "desc": "Lorsqu'il est dans l'équipe, augmente l'attaque des Pals de type Ténèbres de 15~30%. (Effet non cumulable)"
  },
  "YakushimaMonster001": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster001_Blue": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster001_Pink": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster001_Purple": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster001_Rainbow": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster001_Red": {
    "title": "Corps Gélatineux",
    "desc": "Peut être utilisé comme monture pour se déplacer.\nPermet de sauter plus haut lorsqu'il est monté."
  },
  "YakushimaMonster002": {
    "title": "Enchantement",
    "desc": "Lorsqu'il est dans l'équipe, augmente de 40~80% la quantité d'objets obtenus en terrassant des Pals de type Ténèbres. (Effet non cumulable)"
  },
  "YakushimaMonster003": {
    "title": "Soutien de Chauve-souris",
    "desc": "Lorsqu'il est dans l'équipe, apparaît aux côtés du joueur et ramasse automatiquement les objets à proximité."
  },
  "YakushimaMonster003_Purple": {
    "title": "Soutien de Chauve-souris",
    "desc": "Lorsqu'il est dans l'équipe, apparaît aux côtés du joueur et ramasse automatiquement les objets à proximité."
  }
};
